import { useState } from "react";
import { Runs } from "./Runs";
import { Logs } from "./Logs";

/**
 * History: the runs, and the log those runs wrote.
 *
 * Two views of the same record rather than two pages, because they are the same
 * question asked at two altitudes -- "what has run" and "what did any of it
 * actually say" -- and the answer to the second is usually reached from the
 * first.
 */
export function History({ onWatch }: { onWatch: (id: number) => void }) {
  const [view, setView] = useState<"runs" | "logs">("runs");

  return (
    <>
      <div className="viewpick">
        <button className={view === "runs" ? "on" : ""} onClick={() => setView("runs")}>
          Runs
        </button>
        <button className={view === "logs" ? "on" : ""} onClick={() => setView("logs")}>
          Log search
        </button>
      </div>
      {view === "runs" ? <Runs onWatch={onWatch} /> : <Logs onWatch={onWatch} />}
    </>
  );
}
